import api from './api';

export const adminService = {
  resetIncome: () => api.post('/admin/reset-income'),
  clearAllData: () => api.post('/admin/clear-all-data'),
};
